import React from "react";

const ResponsiveImage = ({ large, medium, small, alt }) => (
    <picture>
        <source srcSet={large} media="(min-width:980px)" />
        <source srcSet={medium} media="(min-width:560px)" />
        <img src={small} alt={alt} />
    </picture>
);
export default ResponsiveImage;
